import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { RecordCreateForm } from "./components/RecordCreateForm";

export function NewRecordPage() {
  return (
    <Page title="New Record">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <RecordCreateForm />
      </Container>
    </Page>
  );
}
